import { render, staticRenderFns } from "./action-project-modal.vue?vue&type=template&id=6c85d631&scoped=true"
import script from "./action-project-modal.vue?vue&type=script&lang=js"
export * from "./action-project-modal.vue?vue&type=script&lang=js"
import style0 from "./action-project-modal.vue?vue&type=style&index=0&id=6c85d631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85d631",
  null
  
)

export default component.exports